import widgetInfo from './widgetInfo';
import account from './account';
import wisVehicle from './wis-vehicle';
import pricingModuleData from './pricingModule';
import userProfile from './userProfile';
import shouldPortalPricing from './shouldPortalPricing';
import shouldFetchGMPayments from './shouldFetchGMPayments';

const root = {
	widgetInfo,
	account,
	pricingModuleData,
	userProfile,
	wisVehicle,
	shouldPortalPricing,
	shouldFetchGMPayments
};

export default root;
